import type { BindingScope } from "../../LegalBindingAPI";

const regulatedObjectCodesEqual = (left: string[], right: string[]) => {
  if (left.length !== right.length) {
    return false;
  }

  const remaining = new Map<string, number>();

  for (const code of left) {
    remaining.set(code, (remaining.get(code) ?? 0) + 1);
  }

  for (const code of right) {
    const count = remaining.get(code);

    if (!count) {
      return false;
    }

    remaining.set(code, count - 1);
  }

  return true;
};

export const bindingScopesEqual = (left: BindingScope, right: BindingScope) => {
  if (left.anchor.type !== right.anchor.type) {
    return false;
  }

  if (left.anchor.type === "Site" && left.anchor.siteId !== right.anchor.siteId) {
    return false;
  }

  if (left.regulatedObjects === "ALL" || right.regulatedObjects === "ALL") {
    return left.regulatedObjects === right.regulatedObjects;
  }

  return regulatedObjectCodesEqual(left.regulatedObjects, right.regulatedObjects);
};
